import { useRef, useState } from "react"
import { hideDropdownToggle } from "../../../helpers/Functions";
import { MemberMediaProps } from "../../../typings/memberMedia"
import ProfileImagesSelect from "./ProfileImagesSelect"
import NiceModal from "@ebay/nice-modal-react";

export interface ToolBarActionsProps {
   sentImageMessage: (image: any) => void;
   sentProfileImages: (images: any) => void;
   sendLocation: () => void;
   openBreakTheIceQuestion: () => void;
   profileImages: MemberMediaProps[];
}


const ToolBarActions = ({ openBreakTheIceQuestion, profileImages, sentImageMessage, sentProfileImages, sendLocation }: ToolBarActionsProps) => {
   const inputFile = useRef<any>(null);

   const openSelectImage = () => {
      inputFile?.current.click();
      hideDropdownToggle('w-dropdown-toggle-1');
   }

   const handleImageChange = (event: any) => {
      hideDropdownToggle('w-dropdown-toggle-1');
      const reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = () => {
         NiceModal.show("action_modal", {
            onNext: () => sendImage(event.target.files[0]),
            primaryButtonText: "אישור",
            showCloseButton: true,
            showSeconderyButton: true,
            image: reader.result,
            seconderyButtonText: 'ביטול'
         });
      };
   };

   const sendImage = async (file: any) => {
      NiceModal.hide('action_modal');
      await sentImageMessage(file);

   }

   return (

      <div data-hover="false" data-delay={0} className="chat_insert_menu w-dropdown">
         <div className="chat_menu_but w-dropdown-toggle" />
         <nav className="chat_menu_list w-dropdown-list">
            {/* <div className="chat_menu_group">
                    <ProfileImagesSelect profileImages={profileImages} sentProfileImages={sentProfileImages} />
                </div> */}
            <div className="chat_menu_group">
               <input autoComplete="off" onChange={handleImageChange} type='file' id='file' ref={inputFile} style={{ display: 'none' }} />
               <a onClick={openSelectImage} href="#" className="chat_menu_link w-dropdown-link">
                  שליחת תמונה
               </a>
               {/* <div className="chat_menu_line" />
                    <a href="#" className="chat_menu_link w-dropdown-link">
                        שלח סרטון
                    </a> */}
               {/* <div className="chat_menu_line" /> */}
               {/* <a href="#" className="chat_menu_link w-dropdown-link">
                  שלח הודעה קולית
               </a> */}
               <div className="chat_menu_line" />
               <a href="#" onClick={openBreakTheIceQuestion} className="chat_menu_link w-dropdown-link">
                  לשבור את הקרח
               </a>
               {/* <div className="chat_menu_line" />
               <a href="#" onClick={sendLocation} className="chat_menu_link w-dropdown-link">
                  שיתוף מיקום
               </a> */}
            </div>
         </nav>
      </div>

   )
}

export default ToolBarActions